import React, { Children } from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Privacy() {
  return <div className="pt-20" data-id="element-1486">
      {/* Hero */}
      <section className="pt-16 pb-12 md:pt-24 md:pb-16 bg-gradient-to-br from-gray-50 to-white" data-id="element-1487">
        <div className="container-custom" data-id="element-1488">
          <div className="max-w-4xl mx-auto text-center" data-id="element-1489">
            <div className="w-16 h-16 bg-amber/10 rounded flex items-center justify-center mx-auto mb-6" data-id="element-1490">
              <ShieldCheckIcon className="h-8 w-8 text-amber" data-id="element-1491" />
            </div>
            <h1 className="mb-4" data-id="element-1492">Privacy Policy</h1>
            <p className="text-gray-600" data-id="element-1493">Last Updated: January 2024</p>
          </div>
        </div>
      </section>

      {/* Content */}
      <section className="section-padding bg-white" data-id="element-1494">
        <div className="container-custom" data-id="element-1495">
          <div className="max-w-4xl mx-auto prose prose-lg" data-id="element-1496">
            <div className="bg-amber/5 border-l-4 border-amber p-6 rounded mb-12" data-id="element-1497">
              <p className="text-gray-700 leading-relaxed mb-0" data-id="element-1498">
                <strong data-id="element-1499">Our Commitment:</strong> We respect your privacy and are
                committed to protecting your personal information. This policy
                explains how we collect, use, and safeguard your data when you
                use our website and services.
              </p>
            </div>

            {/* Information We Collect */}
            <div className="mb-12" data-id="element-1500">
              <h2 className="text-navy mb-4" data-id="element-1501">1. Information We Collect</h2>

              <h3 className="text-xl text-navy mb-3" data-id="element-1502">
                Information You Provide
              </h3>
              <p className="text-gray-700 leading-relaxed mb-4" data-id="element-1503">
                When you use our website or services, you may provide us with:
              </p>
              <ul className="space-y-2 text-gray-700 mb-6" data-id="element-1504">
                <li data-id="element-1505">Contact information (name, email, phone number)</li>
                <li data-id="element-1506">
                  Company information (company name, role, team size, industry)
                </li>
                <li data-id="element-1507">
                  Information submitted through forms (strategy call requests,
                  newsletter signups)
                </li>
                <li data-id="element-1508">Communication preferences and feedback</li>
              </ul>

              <h3 className="text-xl text-navy mb-3" data-id="element-1509">
                Information Collected Automatically
              </h3>
              <p className="text-gray-700 leading-relaxed mb-4" data-id="element-1510">
                When you visit our website, we automatically collect:
              </p>
              <ul className="space-y-2 text-gray-700 mb-6" data-id="element-1511">
                <li data-id="element-1512">Device and browser information</li>
                <li data-id="element-1513">IP address and location data</li>
                <li data-id="element-1514">Pages visited and time spent on site</li>
                <li data-id="element-1515">Referring website and search terms</li>
              </ul>
            </div>

            {/* How We Use Information */}
            <div className="mb-12" data-id="element-1516">
              <h2 className="text-navy mb-4" data-id="element-1517">2. How We Use Your Information</h2>
              <p className="text-gray-700 leading-relaxed mb-4" data-id="element-1518">
                We use the information we collect to:
              </p>
              <ul className="space-y-2 text-gray-700" data-id="element-1519">
                <li data-id="element-1520">Provide and improve our services</li>
                <li data-id="element-1521">Respond to your inquiries and schedule strategy calls</li>
                <li data-id="element-1522">
                  Send you relevant content, updates, and resources (with your
                  consent)
                </li>
                <li data-id="element-1523">Analyze website usage and optimize user experience</li>
                <li data-id="element-1524">Comply with legal obligations and protect our rights</li>
              </ul>
            </div>

            {/* Information Sharing */}
            <div className="mb-12" data-id="element-1525">
              <h2 className="text-navy mb-4" data-id="element-1526">
                3. Information Sharing and Disclosure
              </h2>
              <p className="text-gray-700 leading-relaxed mb-4" data-id="element-1527">
                We do not sell your personal information. We may share your
                information with:
              </p>
              <ul className="space-y-2 text-gray-700 mb-6" data-id="element-1528">
                <li data-id="element-1529">
                  <strong data-id="element-1530">Service Providers:</strong> Third-party vendors who
                  help us operate our website and services (e.g., email
                  providers, analytics tools, scheduling platforms)
                </li>
                <li data-id="element-1531">
                  <strong data-id="element-1532">Legal Requirements:</strong> When required by law or
                  to protect our rights and safety
                </li>
                <li data-id="element-1533">
                  <strong data-id="element-1534">Business Transfers:</strong> In connection with a
                  merger, acquisition, or sale of assets
                </li>
              </ul>
              <p className="text-gray-700 leading-relaxed" data-id="element-1535">
                All third-party service providers are contractually obligated to
                protect your information and use it only for the purposes we
                specify.
              </p>
            </div>

            {/* Data Security */}
            <div className="mb-12" data-id="element-1536">
              <h2 className="text-navy mb-4" data-id="element-1537">4. Data Security</h2>
              <p className="text-gray-700 leading-relaxed mb-4" data-id="element-1538">
                We implement appropriate technical and organizational measures
                to protect your personal information against unauthorized
                access, alteration, disclosure, or destruction. These measures
                include:
              </p>
              <ul className="space-y-2 text-gray-700 mb-6" data-id="element-1539">
                <li data-id="element-1540">Encryption of data in transit and at rest</li>
                <li data-id="element-1541">Regular security assessments and updates</li>
                <li data-id="element-1542">Access controls and authentication requirements</li>
                <li data-id="element-1543">Employee training on data protection</li>
              </ul>
              <p className="text-gray-700 leading-relaxed" data-id="element-1544">
                However, no method of transmission over the internet is 100%
                secure. While we strive to protect your information, we cannot
                guarantee absolute security.
              </p>
            </div>

            {/* Your Rights */}
            <div className="mb-12" data-id="element-1545">
              <h2 className="text-navy mb-4" data-id="element-1546">5. Your Rights and Choices</h2>
              <p className="text-gray-700 leading-relaxed mb-4" data-id="element-1547">
                You have the following rights regarding your personal
                information:
              </p>
              <ul className="space-y-2 text-gray-700 mb-6" data-id="element-1548">
                <li data-id="element-1549">
                  <strong data-id="element-1550">Access:</strong> Request a copy of the personal
                  information we hold about you
                </li>
                <li data-id="element-1551">
                  <strong data-id="element-1552">Correction:</strong> Request correction of inaccurate
                  or incomplete information
                </li>
                <li data-id="element-1553">
                  <strong data-id="element-1554">Deletion:</strong> Request deletion of your personal
                  information (subject to legal obligations)
                </li>
                <li data-id="element-1555">
                  <strong data-id="element-1556">Opt-Out:</strong> Unsubscribe from marketing
                  communications at any time
                </li>
                <li data-id="element-1557">
                  <strong data-id="element-1558">Data Portability:</strong> Request a copy of your data
                  in a portable format
                </li>
              </ul>
              <p className="text-gray-700 leading-relaxed" data-id="element-1559">
                To exercise any of these rights, please contact us at
                contact@thehireadvantage.co
              </p>
            </div>

            {/* Cookies */}
            <div className="mb-12" data-id="element-1560">
              <h2 className="text-navy mb-4" data-id="element-1561">
                6. Cookies and Tracking Technologies
              </h2>
              <p className="text-gray-700 leading-relaxed mb-4" data-id="element-1562">
                We use cookies and similar tracking technologies to enhance your
                experience on our website. Cookies are small files stored on
                your device that help us:
              </p>
              <ul className="space-y-2 text-gray-700 mb-6" data-id="element-1563">
                <li data-id="element-1564">Remember your preferences and settings</li>
                <li data-id="element-1565">Understand how you use our website</li>
                <li data-id="element-1566">Improve website performance and functionality</li>
                <li data-id="element-1567">Deliver relevant content and advertising</li>
              </ul>
              <p className="text-gray-700 leading-relaxed" data-id="element-1568">
                You can control cookies through your browser settings. Note that
                disabling cookies may affect website functionality.
              </p>
            </div>

            {/* Children's Privacy */}
            <div className="mb-12" data-id="element-1569">
              <h2 className="text-navy mb-4" data-id="element-1570">7. Children's Privacy</h2>
              <p className="text-gray-700 leading-relaxed" data-id="element-1571">
                Our services are not directed to individuals under 18 years of
                age. We do not knowingly collect personal information from
                children. If you believe we have collected information from a
                child, please contact us immediately.
              </p>
            </div>

            {/* Changes to Policy */}
            <div className="mb-12" data-id="element-1572">
              <h2 className="text-navy mb-4" data-id="element-1573">
                8. Changes to This Privacy Policy
              </h2>
              <p className="text-gray-700 leading-relaxed" data-id="element-1574">
                We may update this Privacy Policy from time to time to reflect
                changes in our practices or legal requirements. We will notify
                you of material changes by posting the updated policy on our
                website and updating the "Last Updated" date. Your continued use
                of our services after changes are posted constitutes acceptance
                of the updated policy.
              </p>
            </div>

            {/* Contact */}
            <div className="mb-12" data-id="element-1575">
              <h2 className="text-navy mb-4" data-id="element-1576">9. Contact Us</h2>
              <p className="text-gray-700 leading-relaxed mb-4" data-id="element-1577">
                If you have questions, concerns, or requests regarding this
                Privacy Policy or our data practices, please contact us:
              </p>
              <div className="bg-gray-50 rounded p-6 border border-gray-200" data-id="element-1578">
                <p className="text-gray-700 mb-2" data-id="element-1579">
                  <strong data-id="element-1580">The HIRE Advantage</strong>
                </p>
                <p className="text-gray-700" data-id="element-1581">
                  Email: contact@thehireadvantage.co
                </p>
              </div>
            </div>

            {/* Footer Note */}
            <div className="bg-navy/5 border-l-4 border-navy p-6 rounded" data-id="element-1582">
              <p className="text-gray-700 leading-relaxed mb-0" data-id="element-1583">
                <strong data-id="element-1584">Note:</strong> This Privacy Policy applies only to
                information collected through our website and services. It does
                not apply to information collected offline or through
                third-party websites linked from our site.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="section-padding bg-gray-50" data-id="element-1585">
        <div className="container-custom" data-id="element-1586">
          <div className="max-w-3xl mx-auto text-center" data-id="element-1587">
            <h2 className="mb-6" data-id="element-1588">Questions About Our Privacy Practices?</h2>
            <p className="text-xl text-gray-600 mb-8 leading-relaxed" data-id="element-1589">
              We are committed to transparency and protecting your privacy. If
              you have any questions or concerns, we are here to help.
            </p>
            <a href="mailto:contact@thehireadvantage.co" className="inline-block bg-amber hover:bg-amber-dark text-white font-bold px-8 py-4 rounded transition-colors shadow-lg" data-id="element-1590">
              Contact Us →
            </a>
          </div>
        </div>
      </section>
    </div>;
}